import React from 'react';
export function WorkersHeader() {
  return <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6" data-id="element-4026" data-mp="32qmdmpuuxr05">
      <div data-id="element-4027" data-mp="14wmi05kz8rc">
        <div className="flex items-center gap-2 mb-1" data-id="element-4028" data-mp="156flwlx9w19">
          <span className="text-xl font-bold text-gray-900" data-id="element-4029" data-mp="f3e6bmsd813z">BCG</span>
          <span className="text-gray-400" data-id="element-4030" data-mp="a3096zsaybkq">|</span>
          <span className="text-sm text-gray-600 font-medium" data-id="element-4031" data-mp="a26wli6nwruo">
            Broadway Construction Group
          </span>
        </div>
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-4032" data-mp="k1pfdvau67l5">Workers</h1>
      </div>

      <div className="flex gap-3" data-id="element-4033" data-mp="jzlbhdcxt8kv">
        <div className="bg-gray-200 rounded px-4 py-2 text-center min-w-[100px]" data-id="element-4034" data-mp="xtm3lo9dvxc9">
          <div className="text-xl font-bold text-gray-900" data-id="element-4035" data-mp="trr4mqexdw1n">272</div>
          <div className="text-[10px] uppercase font-bold text-gray-600" data-id="element-4036" data-mp="tsak80h3s8ci">
            Present Today
          </div>
        </div>
        <div className="bg-amber-100 rounded px-4 py-2 text-center min-w-[100px]" data-id="element-4037" data-mp="12s731lgtaczn">
          <div className="text-xl font-bold text-amber-600" data-id="element-4038" data-mp="12qckuewxcyz9">1</div>
          <div className="text-[10px] uppercase font-bold text-amber-600" data-id="element-4039" data-mp="2awszmc6md240">
            Expiring soon
          </div>
        </div>
        <div className="bg-red-100 rounded px-4 py-2 text-center min-w-[100px]" data-id="element-4040" data-mp="2fw5y5u6urxmf">
          <div className="text-xl font-bold text-red-600" data-id="element-4041" data-mp="2ks4hh3dbqpfz">11</div>
          <div className="text-[10px] uppercase font-bold text-red-600" data-id="element-4042" data-mp="2ow2ffaqwxu7g">
            Missing / expired
          </div>
        </div>
      </div>
    </div>;
}